
import * as React from 'react'
import { Text, View, ScrollView, TouchableOpacity, Image, ActivityIndicator, TextInput, Platform } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Step } from '../components'
import images from '../../assets'
import moment from 'moment'
import axios from 'axios'
import { showMessage } from "react-native-flash-message"

export default React.memo(function Booking({ navigation, route }) {
    const { booking } = route.params

    const { colors, fontFamily } = useTheme()
    const insets = useSafeAreaInsets()
    const [data, setData] = React.useState({ ...booking.customer, note: booking.note })
    const ref_name = React.useRef()
    const ref_phone = React.useRef()
    const ref_email = React.useRef()
    const ref_note = React.useRef()

    console.log(booking)

    const continueBooking = () => {
        let regex_phone = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g

        if (!data?.name) return showMessage({
            message: "Thông báo",
            description: "Bạn chưa nhập vào họ tên!",
            type: "warning",
        })
        if (data?.phone) {
            if (!regex_phone.test(data?.phone))
                return showMessage({
                    message: "Thông báo",
                    description: "Số điện thoại bạn nhập vào không đúng!",
                    type: "warning",
                })
        } else return showMessage({
            message: "Thông báo",
            description: "Bạn chưa nhập vào số điện thoại!",
            type: "warning",
        })

        let regex_email = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g

        if (data?.email && !regex_email.test(data?.email)) {
            return showMessage({
                message: "Thông báo",
                description: "Email bạn nhập vào không đúng!",
                type: "warning",
            })
        }
        let tmp = { ...booking }
        tmp.note = data.note
        tmp.customer = { ...data }
        navigation.navigate('EditTransit', { booking: tmp })
    }

    return (
        <View style={{ flex: 1, position: 'relative' }}>
            <View style={{ backgroundColor: colors.primary, paddingTop: insets.top ? insets.top : 0 }}>
                <View style={{
                    flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: 48,
                    position: 'relative',
                }}>
                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Thông tin vé xe</Text>
                    <View style={{ position: 'absolute', height: '100%', left: 0, top: 0 }}>
                        <TouchableOpacity onPress={() => {
                            if (navigation.canGoBack())
                                navigation.pop()
                            else window.history.back()
                        }}
                            style={{ height: '100%', justifyContent: 'center', alignItems: 'center', paddingLeft: 16 }}>
                            <Image source={images.icons.back} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
            <View>
                <Step step={3} />
            </View>

            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={{ padding: 16, backgroundColor: 'white' }}>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }}>Thông tin của bạn</Text>

                    <Text style={{ fontFamily: fontFamily.bold, marginTop: 16 }}>Họ và tên <Text style={{ color: 'red' }}>*</Text></Text>
                    <TextInput
                        ref={ref_name}
                        returnKeyType='next' autoCorrect={false}
                        value={data.name}
                        style={{ borderRadius: 4, backgroundColor: '#F0F2F5', height: 45, paddingHorizontal: 16, marginTop: 5, fontFamily: fontFamily.regular }}
                        placeholder='Nhập họ tên của người đi' onChangeText={name => setData({ ...data, name })}
                        onSubmitEditing={() => ref_phone.current.focus()} />

                    <Text style={{ fontFamily: fontFamily.bold, marginTop: 16 }}>Số điện thoại <Text style={{ color: 'red' }}>*</Text></Text>
                    <TextInput
                        ref={ref_phone}
                        returnKeyType='next' autoCorrect={false}
                        value={data.phone}
                        style={{ borderRadius: 4, backgroundColor: '#F0F2F5', height: 45, paddingHorizontal: 16, marginTop: 5, fontFamily: fontFamily.regular }}
                        placeholder='Nhập số điện thoại của người đi' onChangeText={phone => setData({ ...data, phone })}
                        onSubmitEditing={() => ref_email.current.focus()} />

                    <Text style={{ fontFamily: fontFamily.bold, marginTop: 16 }}>Email</Text>
                    <TextInput
                        ref={ref_email}
                        returnKeyType='next' autoCorrect={false}
                        value={data.email}
                        style={{ borderRadius: 4, backgroundColor: '#F0F2F5', height: 45, paddingHorizontal: 16, marginTop: 5, fontFamily: fontFamily.regular }}
                        placeholder='Nhập địa chỉ e-mail của người đi' onChangeText={email => setData({ ...data, email })}
                        onSubmitEditing={() => ref_note.current.focus()} />

                    <Text style={{ fontFamily: fontFamily.bold, marginTop: 16 }}>Ghi chú</Text>
                    <TextInput
                        ref={ref_note}
                        returnKeyType='done' autoCorrect={false}
                        value={data.note}
                        style={{ borderRadius: 4, backgroundColor: '#F0F2F5', height: 45, paddingHorizontal: 16, marginTop: 5, fontFamily: fontFamily.regular }}
                        placeholder='Nhập ghi chú của người đi' onChangeText={note => setData({ ...data, note })} />
                </View>

                <View style={{ padding: 16, backgroundColor: 'white' }}>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.bold }}>Thông tin vé</Text>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 12 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Mã vé</Text>
                        <Text style={{ color: '#1F76E5', fontFamily: fontFamily.bold, fontSize: 16, flex: 5 }}>{booking.code}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 8 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Ngày khởi hành</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>{moment(booking.trip?.time, 'DD-MM-YYYY HH:mm').format('HH:mm DD/MM/YYYY')}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 8 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Điểm lên xe</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>
                            {booking.pick_up?.address}
                        </Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 8 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Điểm xuống xe</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>
                            {booking.drop_off?.address}
                        </Text>
                    </View>

                    <View style={{ width: '100%', backgroundColor: '#E9E9E9', height: 1, marginVertical: 8 }} />
                    <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Tên tuyến</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>{booking.trip?.node?.route?.name}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 8 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Hạng xe</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>{booking.trip?.product?.name}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 8 }}>
                        <Text style={{ color: '#514F4F', flex: 4, fontFamily: 'Nunito_400Regular' }}>Số ghế/giường</Text>
                        <Text style={{ fontFamily: fontFamily.semi_bold, flex: 5 }}>{booking.name}</Text>
                    </View>
                </View>
            </ScrollView>

            <View style={{
                paddingHorizontal: 16, paddingTop: 12, paddingBottom: 12 + (insets.bottom ? insets.bottom - 16 : 0), backgroundColor: 'white',
                borderTopWidth: 1, borderTopColor: '#CACBD0'
            }}>
                <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                    <Text style={{ flex: 1, fontFamily: 'Nunito_400Regular' }}>Tổng tiền</Text>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }}>{
                        (Intl.NumberFormat('vi-VN').format(booking.price))
                    }đ</Text>
                </View>
                <TouchableOpacity style={{
                    height: 45, backgroundColor: colors.primary, marginTop: 12,
                    justifyContent: 'center', alignItems: 'center', borderRadius: 6
                }} onPress={continueBooking}>
                    <Text style={{ fontSize: 16, fontFamily: fontFamily.semi_bold }}>Tiếp tục</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
})
